import { render, staticRenderFns } from "./HealthDashboard.vue?vue&type=template&id=1e72c195&"
import script from "./HealthDashboard.vue?vue&type=script&lang=ts&"
export * from "./HealthDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./HealthDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports